export default __webpack_public_path__ + "static/media/event-info-balloon-1.09e602c9.jpeg";